import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ModalNavigator } from 'components';

import Categories from './categories';
import Products from './products';

export default class AddProduct extends React.Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.state = {
      currentCategory: null,
    };

    this.clickCategoryHandler = this.clickCategoryHandler.bind(this);
    this.modalNavigatorRefHandler = this.modalNavigatorRefHandler.bind(this);
    this.next = this.next.bind(this);
    this.selectProductHandler = this.selectProductHandler.bind(this);
  }

  /* Handlers */

  selectProductHandler(product, category) {
    const { onSelectProduct } = this.props;
    if (onSelectProduct) {
      onSelectProduct(product, category);
    }
  }

  clickCategoryHandler(evt, category) {
    if (category && category.singleProduct) {
      this.selectProductHandler(null, category);
      return;
    }
    const { availableProducts } = this.props;
    const map = availableProducts ? availableProducts.categoriesByName : null;
    let productCategory = null;
    if (category && map) {
      const { categoryName } = category;
      productCategory = map[categoryName];
    }
    const productList = productCategory ? productCategory.products : null;
    this.setState({ currentCategoryProductList: productList, currentCategory: category });
    this.next();
  }

  modalNavigatorRefHandler(modalNavigator) {
    this.modalNavigator = modalNavigator;
  }

  /* Methods */

  next() {
    this.modalNavigator.getWrappedInstance().next();
  }

  /* Render */

  getProductsPageData() {
    const { currentCategory, currentCategoryProductList } = this.state;
    const { config } = this.props;

    let title = null;
    let component = null;
    const categoryLabelId = currentCategory ? currentCategory.labelId : null;
    if (categoryLabelId) {
      title = (
        <FormattedMessage id={`configurator.addProductModal.categoryTitles.${categoryLabelId}`} />
      );
      component = (
        <Products
          category={currentCategory}
          config={config}
          products={currentCategoryProductList}
          onSelect={this.selectProductHandler}
        />
      );
    }

    return {
      title,
      component,
    };
  }

  render() {
    const { config, products, availableProducts } = this.props;
    const views = [
      {
        title: <FormattedMessage id="configurator.addProductModal.title" />,
        component: (
          <Categories
            config={config}
            products={products}
            availableProducts={availableProducts}
            onClickCategory={this.clickCategoryHandler}
          />
        ),
      },
      this.getProductsPageData(),
    ];
    return (
      <ModalNavigator
        ref={this.modalNavigatorRefHandler}
        views={views}
      />
    );
  }
}

AddProduct.propTypes = {
  availableProducts: PropTypes.any,
  config: PropTypes.any,
  onSelectProduct: PropTypes.func,
  products: PropTypes.any,
};



// WEBPACK FOOTER //
// ./js/views/systems/detail/design/add-product/index.jsx